"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_CIMA_RENEWAL_SEASON_INFO = exports.GET_RENEWAL_SEASON_INFO = exports.getRenewalSeasonInfo = exports.SEND_MESSAGE = void 0;
exports.SEND_MESSAGE = `
	query sendMessage($message: String!) {
		sendMessage(message: $message)
	}
`;
exports.getRenewalSeasonInfo = `
        getRenewalSeasonInfo {
			isRenewalSeason
			startDate
			endDate
			fbIsRenewalSeason
			fbStartDate
			fbEndDate
			isCimaRenewalSeason
            cimaStartDate
            cimaEndDate
            fbIsCimaRenewalSeason
            fbCimaStartDate
            fbCimaEndDate
			isMipRenewalSeason
  			mipStartDate
  			mipEndDate
		}
`;
exports.GET_RENEWAL_SEASON_INFO = `
	query getRenewalSeasonInfo {
		${exports.getRenewalSeasonInfo}
	}
`;
exports.GET_CIMA_RENEWAL_SEASON_INFO = `
	query getCimaRenewalSeasonInfo {
		getCimaRenewalSeasonInfo {
			isRenewalSeason
			startDate
			endDate
			fbIsRenewalSeason
			fbStartDate
			fbEndDate
		}  
	}
`;
//# sourceMappingURL=app-queries.js.map